import {getItemFromSession, getObjectFromSession} from "../sharedGlobal";
import {moduleNamespace, STAGES} from "./constants";

const defaultWizardState = () => ({
  layout: {},
  configuration: getObjectFromSession(moduleNamespace, 'configuration') ?? {},

  stage: STAGES[0],

  name: getItemFromSession(moduleNamespace, 'name') ?? '',
  email: getItemFromSession(moduleNamespace, 'email') ?? '',
  operationCountry: getItemFromSession(moduleNamespace, 'operationCountry') ?? 'United States',
  password: '', // TODO: Check security implications, not in session, but is VueX vulnerable?

  price: {
    currency: 'USD',
    billingPeriod: 'MONTH',
    showTax: false,
    fullPrice: {
      exVat: 0,
      incVat: 0,
      exVatDisplay: '',
      incVatDisplay: '',
    },
  },

  discountMetaData: null,

  stripePaymentMethodId: getItemFromSession(moduleNamespace, 'stripePaymentMethodId') ?? null,

  stripeRedirect: false,

  errors: {},
});

import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: defaultWizardState(),
  getters,
  actions,
  mutations,
};
